module.exports = __webpack_public_path__ + "img/goods-mobile-4.73f4f7e7.png";